export default "__VITE_ASSET__a3acb079__"